export default class AuthenticationRequest {

    loginId: string;
    password: string;
    totp: string;
    firstEntryLogin: boolean;
    firstEntryPassword: boolean;
    firstEntryTeamID: boolean;

    constructor(data?: any) {
        this.loginId = data?.loginId ?? "";
        this.password = data?.password ?? "";
        this.totp = data?.totp ?? "";
        this.firstEntryLogin = data?.firstEntryLogin ?? true;
        this.firstEntryPassword = data?.firstEntryPassword ?? true;
        this.firstEntryTeamID = data?.firstEntryTeamID ?? true;
    }
}